import { useQuery } from "react-query";
import { toast } from "react-toastify";
import { getAppointmentFeedbacks } from "api/Statistics";


interface FiltersProps {
    worker?: string,
    from_date_of_creation?: string,
    to_date_of_creation?: string,
    filter_on?: string
}
export const useAppointmentFeedbacks = (
    filters?: FiltersProps
) => {

    const { data, isLoading } = useQuery<Array<any>>(
        ['appointments',filters?.worker, filters?.from_date_of_creation, filters?.to_date_of_creation, filters?.filter_on],
        () => {
            return getAppointmentFeedbacks({
                worker: filters?.worker === 'All agents' ? null : filters?.worker,
                from_date_of_creation: filters?.filter_on === 'Individual' ? filters?.from_date_of_creation : null,
                to_date_of_creation: filters?.filter_on === 'Individual' ?  filters?.to_date_of_creation : null,
                filter_on: filters?.filter_on === 'Individual' ? null : filters?.filter_on
            });
        }, {
        onError() {
            toast.error(`Something went wrong. Please try again later.`);
        },
        enabled: true,
        refetchOnMount: true,
    }
    );

    return {
        data,
        isLoading,
    };
};
